import React from 'react';

const URL_REGEX = /(https?:\/\/[^\s<]+)/g;

export function Linkify({ children, className = "" }) {
  if (typeof children !== 'string') return <span className={className}>{children}</span>;

  const parts = children.split(URL_REGEX);
  return (
    <span className={className}>
      {parts.map((part, i) =>
        URL_REGEX.test(part) ? (
          <a key={i} href={part} target="_blank" rel="noopener noreferrer"
            className="text-[#FF6B35] hover:underline break-all">
            {part}
          </a>
        ) : (
          <React.Fragment key={i}>{part}</React.Fragment>
        )
      )}
    </span>
  );
}
